<template>
    <div class="popBg" v-if="isShow">
        <div class="popBox" :style="{width: width}">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <slot name="title">
                        <span v-html="title"></span>
                        <span class="el-icon-close fr close" @click="closeForm"></span>
                    </slot>
                </div>
                <div class="searchBox">
                    <slot name="search">
                        <el-form :inline="true" class="">
                            <el-form-item label="">
                                <el-input v-model="searchValue" :placeholder="searchTips"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="searchEvent">搜索</el-button>
                            </el-form-item>
                        </el-form>
                    </slot>
                </div>
                <div class="popBody" ref="popBody">
                    <div class="body">
                        <el-table
                                :data="tableData"
                                height="300"
                                border
                                highlight-current-row
                                @current-change="handleCurrentChange"
                                style="width: 100%">
                            <el-table-column
                                    v-for="(nav, k) in tableFields"
                                    :prop="nav.field"
                                    :label="nav.label"
                                    :width="nav.width"
                                    :key="k">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="popFoot">
                    <div class="page-box">
                        <el-pagination
                                @size-change="loadListData"
                                @current-change="loadListData"
                                :current-page="page.nowPage"
                                :page-sizes="page.pageSizes"
                                :page-size="page.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="page.count">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "PopListSelect"
        ,model: {
            event: "showChange",
            prop: "isShow"
        }
        ,props: {
            isShow: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ""
            },
            width: {
                type: String,
                default: "680px"
            },
            tableFields: {
                type: Array,
                default: [],
            },
            tableData: {
                type: Array,
                default: [],
            },
            searchTips: {
                type: String,
                default: "请输入内容"
            },
            allCount: {
                type: Number,
                default: 0
            }
        }
        ,data: () => ({
            searchValue: "",

            // tableFields: [
            //     {
            //         label: "活动名称",
            //         field: "title",
            //         width: "180"
            //     }
            // ],
            // tableData: [],

            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
        })
        ,mounted: function() {
            obj.scrollbar(".popBody");
        }
        ,methods: {
            //关闭
            closeForm: function (e) {
                this.$emit("showChange", false);
            },

            //搜索
            searchEvent: function () {
                this.page.nowPage = 1;
                this.loadListData();
            },

            //加载新数据
            loadListData: function () {
                let postData = {
                    keyword: this.searchValue,
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                };
                this.$emit("loadData", postData);
            },

            //选择结果
            handleCurrentChange: function (data) {
                this.$emit("selected", data);
                this.$emit("showChange", false);
            }
        }
        ,watch: {
            allCount: function (data) {
                this.page.count = data;
            }
        }
    }
</script>

<style scoped>
    .popBg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
    }
    .close{
        font-weight: bold;
    }
    .searchBox{
        padding: 0px 10px 10px;
    }
    .popBox{
        margin: 50px auto 0;
    }
    .popBox .title{
        font-size: 16px;
    }
    .popBody{
        max-height: 300px;
        padding-right: 0px;
        overflow: auto;
    }
    .popBody .body{
        padding: 0 10px;
    }
    .popFoot{
        padding-top: 20px;
        text-align: center;
    }

    .el-form--inline .el-form-item{
        margin-bottom: 0px;
    }
</style>
